import { z } from 'zod';
import { agentChatModelSchema } from '../enums/agent.js';
import { StatusTypeSchema } from '../enums/status.js';
import { promptDetailsSchema, promptListItemSchema, promptMessageSchema } from '../types/prompts.js';

export const getPromptsResponseSchema = z.object({
  items: z.array(promptListItemSchema),
});

export const createPromptRequestBodySchema = z.object({
  name: z.string().min(1),
  description: z.string().default(''),
  messages: z.array(promptMessageSchema).default([]),
  inputSchema: z.record(z.string(), z.unknown()).default({}),
  llmModel: agentChatModelSchema.default('gpt-4.1-mini'),
  structuredOutputSchema: z.record(z.string(), z.unknown()).nullable().optional(),
});

export const createPromptResponseSchema = z.object({
  id: z.number(),
  identifier: z.string().uuid(),
});

export const getPromptRequestParamsSchema = z.object({
  promptId: z.coerce.number(),
});

export const getPromptResponseSchema = promptDetailsSchema;

export const updatePromptRequestParamsSchema = z.object({
  promptId: z.coerce.number(),
});

export const updatePromptRequestBodySchema = z.object({
  name: z.string().min(1),
  description: z.string(),
  status: StatusTypeSchema,
  messages: z.array(promptMessageSchema),
  inputSchema: z.record(z.string(), z.unknown()),
  llmModel: agentChatModelSchema,
  structuredOutputSchema: z.record(z.string(), z.unknown()).nullable().optional(),
});

export const deletePromptRequestParamsSchema = z.object({
  promptId: z.coerce.number(),
});

export namespace UpdatePromptStatus {
  export const paramsSchema = z.object({
    promptId: z.coerce.number(),
  });
  export type Params = z.infer<typeof paramsSchema>;

  export const requestBodySchema = z.object({
    status: StatusTypeSchema,
  });
  export type RequestBody = z.infer<typeof requestBodySchema>;

  export const responseSchema = promptDetailsSchema;
  export type Response = z.infer<typeof responseSchema>;
}
